/**
 * TheChocoMug Interactive Experience (Vanilla JS, Fast, Zero Dependencies)
 */

document.addEventListener('DOMContentLoaded', function () {
  // Elements
  const mainImage = document.getElementById('chocomugMainImg');
  const thumbs = document.querySelectorAll('.chocomug-thumb');
  const swatches = document.querySelectorAll('.chocomug-swatch');
  const bundleCards = document.querySelectorAll('.chocomug-bundle-card');
  const currentPriceEl = document.getElementById('chocomugCurrentPrice');
  const comparePriceEl = document.getElementById('chocomugComparePrice');
  const saveBadgeEl = document.getElementById('chocomugSaveBadge');
  const ctaBtn = document.getElementById('chocomugCtaBtn');
  const stickyBar = document.getElementById('chocomugStickyBar');
  const stickyBtn = document.getElementById('chocomugStickyBtn');
  const stickyPrice = document.getElementById('chocomugStickyPrice');
  const stickyThumb = document.getElementById('chocomugStickyThumb');
  const accordionHeaders = document.querySelectorAll('.chocomug-acc-header');
  const selectedColorNameEl = document.getElementById('selectedColorName');

  // Variant Data from Liquid
  const variants = window.TheChocoMugVariants || [];
  let selectedVariantId = window.TheChocoMugVariantId || (variants[0] ? variants[0].id : 53149806199101);
  let currentColor = 'red';
  let currentColorName = 'Red';
  let currentBundle = 2; // Default to 2x Duo Pack

  // Gallery Elements
  const galleryTrack = document.getElementById('chocomugGalleryTrack');
  const gallerySlides = document.querySelectorAll('.chocomug-gallery-slide');
  const dots = document.querySelectorAll('.chocomug-dot');
  const totalSlides = gallerySlides.length;
  let activeSlideIndex = 0;

  // Navigate to slide by index
  function goToSlide(index, smooth = true) {
    if (!galleryTrack || totalSlides === 0) return;
    activeSlideIndex = Math.max(0, Math.min(index, totalSlides - 1));
    const targetSlide = gallerySlides[activeSlideIndex];
    if (targetSlide) {
      galleryTrack.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto'
      });
      syncActiveState(activeSlideIndex);
    }
  }

  // Sync active states (dots, thumbs, sticky thumb, color if variant)
  function syncActiveState(index) {
    activeSlideIndex = index;

    // Update Dots
    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === index);
    });

    // Update Thumbs
    thumbs.forEach((thumb, idx) => {
      const isMatch = idx === index;
      thumb.classList.toggle('active', isMatch);
      if (isMatch) {
        try {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } catch (e) {}
      }
    });

    // Update Sticky Bar Thumbnail
    const activeSlide = gallerySlides[index];
    if (activeSlide && stickyThumb) {
      const img = activeSlide.querySelector('img');
      if (img && img.src) stickyThumb.src = img.src;
    }

    // Check if this slide is mapped to a color variant
    if (activeSlide && activeSlide.dataset.color) {
      const colorKey = activeSlide.dataset.color;
      const colorTitle = activeSlide.dataset.colorTitle || (colorKey.charAt(0).toUpperCase() + colorKey.slice(1));
      selectColor(colorKey, colorTitle, null, false); // false = don't re-scroll gallery
    }
  }

  // Track scroll listener (fires on native mobile swipe and snap)
  let scrollTimeout = null;
  if (galleryTrack) {
    galleryTrack.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const slideWidth = galleryTrack.clientWidth || 1;
        const newIndex = Math.round(galleryTrack.scrollLeft / slideWidth);
        if (newIndex !== activeSlideIndex && newIndex >= 0 && newIndex < totalSlides) {
          syncActiveState(newIndex);
        }
      }, 50);
    }, { passive: true });
  }

  // Dots click
  dots.forEach((dot) => {
    dot.addEventListener('click', function () {
      const idx = parseInt(this.dataset.index, 10);
      goToSlide(idx);
    });
  });

  // Set active color swatch & update gallery
  function selectColor(colorKey, colorName, variantId = null, scrollGallery = true) {
    currentColor = colorKey.toLowerCase();
    currentColorName = colorName;

    if (selectedColorNameEl) {
      selectedColorNameEl.textContent = colorName;
    }

    // Find variant if not passed
    const matchedVariant = variants.find(v => v.color === currentColor || v.title.toLowerCase() === currentColor);
    if (matchedVariant) {
      selectedVariantId = matchedVariant.id;

      // Update pricing dynamically from real variant data
      if (currentPriceEl && matchedVariant.priceFormatted) {
        currentPriceEl.textContent = matchedVariant.priceFormatted;
      }
      if (comparePriceEl) {
        if (matchedVariant.comparePriceFormatted) {
          comparePriceEl.textContent = matchedVariant.comparePriceFormatted;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (saveBadgeEl) {
        if (matchedVariant.discountPercentage && matchedVariant.discountPercentage > 0) {
          saveBadgeEl.textContent = `SAVE ${matchedVariant.discountPercentage}%`;
          saveBadgeEl.style.display = '';
        } else {
          saveBadgeEl.style.display = 'none';
        }
      }
    } else if (variantId) {
      selectedVariantId = variantId;
    }

    // Update active swatch button
    swatches.forEach(swatch => {
      const isMatch = swatch.dataset.color === currentColor || swatch.dataset.colorName.toLowerCase() === currentColor;
      swatch.classList.toggle('active', isMatch);
    });

    // Scroll gallery to the matching color slide
    if (scrollGallery && gallerySlides.length > 0) {
      let matchedIndex = -1;
      gallerySlides.forEach((slide, idx) => {
        if (slide.dataset.color && slide.dataset.color.toLowerCase() === currentColor) {
          if (matchedIndex === -1) matchedIndex = idx;
        }
      });
      if (matchedIndex !== -1) {
        goToSlide(matchedIndex);
      }
    }
  }

  // Thumb click listener
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', function () {
      goToSlide(idx);
    });
  });

  // Swatch click listener
  swatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
      const colorKey = this.dataset.color;
      const colorName = this.dataset.colorName;
      const variantId = this.dataset.variantId;
      selectColor(colorKey, colorName, variantId, true);
    });
  });

  // Bundle card selection listener
  bundleCards.forEach(card => {
    function activateCard() {
      bundleCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      const qty = parseInt(card.dataset.qty, 10);
      currentBundle = qty;

      const price = card.dataset.price;
      if (stickyPrice) stickyPrice.textContent = price;
    }

    card.addEventListener('click', function () {
      activateCard();
    });

    const selects = card.querySelectorAll('.bundle-picker-select');
    selects.forEach(sel => {
      sel.addEventListener('change', activateCard);
      sel.addEventListener('focus', activateCard);
      sel.addEventListener('click', function (e) {
        e.stopPropagation();
        activateCard();
      });
    });
  });

  // Accordion Logic (Self-contained, smoothly toggles open/close on header click)
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function (e) {
      e.preventDefault();
      const currentItem = this.closest('.chocomug-acc-item');
      if (!currentItem) return;

      const parentAccordions = this.closest('.chocomug-accordions');
      const isAlreadyOpen = currentItem.classList.contains('open');

      if (parentAccordions) {
        parentAccordions.querySelectorAll('.chocomug-acc-item').forEach(item => {
          item.classList.remove('open');
        });
      }

      if (!isAlreadyOpen) {
        currentItem.classList.add('open');
      }
    });
  });

  // Sticky Bar Scroll Listener
  window.addEventListener('scroll', function () {
    if (!ctaBtn || !stickyBar) return;
    const ctaPos = ctaBtn.getBoundingClientRect().bottom;
    if (ctaPos < 0) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  });

  // Open Cart Drawer Function
  function openCartDrawer() {
    // 1. Try theme drawer element open() method
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    // 2. Try theme drawer trigger click
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]') 
                 || document.querySelector('[aria-controls="cart-drawer"]')
                 || document.querySelector('.header-actions__cart-icon button');
    if (trigger) {
      trigger.click();
      return;
    }

    // 3. Try Shopify.actions.openCart
    if (window.Shopify?.actions?.openCart) {
      window.Shopify.actions.openCart();
      return;
    }

    // 4. Fallback: native dialog showModal
    const dialog = document.querySelector('theme-drawer#cart-drawer dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      drawer?.setAttribute('open', '');
    }
  }

  // Add to Cart handler (AJAX -> Accurately adds selected bundle items -> Opens Slide-Out Cart Drawer)
  async function handleAddToCart() {
    const btn = ctaBtn;
    if (!btn) return;

    btn.innerHTML = '<span>Adding to Cart...</span>';
    btn.style.opacity = '0.85';
    btn.disabled = true;

    if (stickyBtn) {
      stickyBtn.textContent = 'Adding...';
      stickyBtn.disabled = true;
    }

    // Determine currently selected pack
    const selectedBundleCard = document.querySelector('.chocomug-bundle-card.selected') || bundleCards[1];
    const bundleQty = parseInt(selectedBundleCard?.dataset?.qty || '2', 10);
    const bundleTitle = selectedBundleCard?.querySelector('.bundle-title')?.textContent.trim() || `${bundleQty}x Pack`;

    // Map to group quantities by variant ID
    const variantMap = new Map();

    if (bundleQty === 1) {
      variantMap.set(selectedVariantId, {
        id: selectedVariantId,
        quantity: 1
      });
    } else {
      const selects = selectedBundleCard?.querySelectorAll('.bundle-picker-select');
      if (selects && selects.length > 0) {
        selects.forEach((sel) => {
          let variantId = parseInt(sel.value, 10);

          if (isNaN(variantId) || variantId <= 0) {
            const match = variants.find(v => v.title.toLowerCase() === sel.value.toLowerCase() || v.color === sel.value.toLowerCase());
            variantId = match ? match.id : selectedVariantId;
          }

          if (variantMap.has(variantId)) {
            variantMap.get(variantId).quantity += 1;
          } else {
            variantMap.set(variantId, {
              id: variantId,
              quantity: 1
            });
          }
        });
      } else {
        variantMap.set(selectedVariantId, {
          id: selectedVariantId,
          quantity: bundleQty
        });
      }
    }

    const items = Array.from(variantMap.values());

    try {
      // 1. Clear existing cart so the newly chosen bundle cleanly replaces previous selection
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: '{}'
      });

      // 2. Add bundle items
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer-section'
        })
      });

      if (!addRes.ok) throw new Error('Add to cart failed');
      const data = await addRes.json();

      // Button feedback
      btn.innerHTML = '<span>✓ Added to Cart!</span>';
      if (stickyBtn) stickyBtn.textContent = '✓ Added!';

      setTimeout(() => {
        btn.innerHTML = '<span>Add to Cart</span>';
        btn.style.opacity = '1';
        btn.disabled = false;
        if (stickyBtn) {
          stickyBtn.textContent = 'Add to Cart';
          stickyBtn.disabled = false;
        }
      }, 1200);

      // Re-render cart drawer inner HTML
      if (data.sections && data.sections['cart-drawer-section']) {
        const sectionHtml = data.sections['cart-drawer-section'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');

        const newInner = doc.querySelector('.cart-drawer__inner');
        const currentInner = document.querySelector('cart-drawer-component .cart-drawer__inner');
        if (newInner && currentInner) {
          currentInner.replaceWith(newInner);
        }
      }

      // Update cart count badge
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const countEls = document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"]');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.classList.remove('hidden');
      });
      const bubbles = document.querySelectorAll('.cart-bubble');
      bubbles.forEach(b => b.classList.remove('visually-hidden'));

      // Open side drawer!
      setTimeout(openCartDrawer, 150);
    } catch (err) {
      console.error(err);
      btn.innerHTML = '<span>Add to Cart</span>';
      btn.style.opacity = '1';
      btn.disabled = false;
      if (stickyBtn) {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      }
      openCartDrawer();
    }
  }

  if (ctaBtn) ctaBtn.addEventListener('click', handleAddToCart);
  if (stickyBtn) stickyBtn.addEventListener('click', handleAddToCart);
});
